import { makeAutoObservable } from 'mobx';
import { WarrantI18N } from '../../models';
import apiManage from '../../request';
import GlobalNotification from '../../component/common/snackbar';
import i18n from '../../i18n';

// 产品数据管理
export class ProductListState implements ProductListData {

    constructor() {
        makeAutoObservable(this);
    }

    // *********************
    // Attributes
    // *********************

    // 产品数据列表
    productList: WarrantI18N[] = [];
    dataTotal: number = 0;
    // 表格加载
    isTableLoading: boolean = false;
    // 弹窗加载loading
    isLoading: boolean = false;
    // 详情
    // 排序参数
    extraSortParams: {
        sort_key: string,
        sort_value: number
    } = { sort_key: '', sort_value: 0 };
    // 显示详情
    showUnit: boolean = false;
    // 点击产品列表行详情按钮进去的数据
    enterResellerDetailObj: {
        key: number;
        product: WarrantI18N
    } = {
            // 进入产品详情索引
            key: -1,
            // 进入产品详情数据
            product: {}
        };

    // 初始化
    async init() {
        await this.getProductListData()
    }

    setIsOpenDetail(val: boolean) {
        this.showUnit = val
    }



    // 表格加载
    loadTable() {
        return this.isTableLoading = true;
    }

    // 加载完毕
    loadedTable() {
        return this.isTableLoading = false;
    }

    // 开启加载  弹窗loading
    load() {
        this.isLoading = true
    }

    // 关闭加载  弹窗loading
    loaded() {
        this.isLoading = false;
    }

    // 返回产品管理列表
    async goBack() {
        this.showUnit = false;
        // 并刷新数据
        await this.init();
    }

    updateProduct(data: WarrantI18N) {
        this.enterResellerDetailObj.product = data;
    }

    // 更新数组
    updateData(data: WarrantI18N[]) {
        this.productList = data;
        this.dataTotal = data.length;
    }

    async getProductListData() {
        // 开启加载
        this.loadTable();
        // 请求集团接口
        const result = await apiManage.getWarrantI18N();
        if (result.message === 'canceled') {
            // 请求被取消
            return
        }
        // 获取成功
        if (!result.error) {
            const data = result.warrantPoint?.concat(result.warrantCollection || []) || []
            this.updateData(data)
        } else {
            // 获取失败
            GlobalNotification.error(i18n.t('general_text_fetch_data_error'));
        }
        // 关闭加载
        this.loadedTable();
    }

}

// 页数据
type ProductListData = {
    // 产品列表
    productList: Array<WarrantI18N>;
    // 表格加载
    isTableLoading: boolean;
    // 弹窗加载loading
    isLoading: boolean;
}